export const GET_STOCK_CONFIGURE_LIST = 'GET_STOCK_CONFIGURE_LIST';
export const GET_STOCK_CONFIGURE_LIST_SUCCESS = 'GET_STOCK_CONFIGURE_LIST_SUCCESS';
export const GET_STOCK_CONFIGURE_LIST_FAIL = 'GET_STOCK_CONFIGURE_LIST_FAIL';

export const ADD_NEW_STOCK_LEVEL = 'ADD_NEW_STOCK_LEVEL';
export const ADD_NEW_STOCK_LEVEL_SUCCESS = 'ADD_NEW_STOCK_LEVEL_SUCCESS';
export const ADD_NEW_STOCK_LEVEL_FAIL = 'ADD_NEW_STOCK_LEVEL_FAIL';

export const DELETE_STOCK_LEVEL = 'DELETE_STOCK_LEVEL';
export const DELETE_STOCK_LEVEL_SUCCESS = 'DELETE_STOCK_LEVEL_SUCCESS';
export const DELETE_STOCK_LEVEL_FAIL = 'DELETE_STOCK_LEVEL_FAIL';
